import {
    GET_CURRENT_VENDOR
} from './constants';

const initialState = {
    currentVendor: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_VENDOR: {
            return {
                ...state,
                currentVendor: action.payload,
            };
        }
        default:
            return state;
    }
};

